import React from 'react';
import Footer from './Footer';

export default function ContactUs() {
  return (
    <div className="content-page">
      <div className="content-container">
        <div className="content-hero">
          <h1>Get In Touch</h1>
          <p className="page-subtitle">Join our community and connect with other plant enthusiasts</p>
        </div>

        <div className="content-section" style={{ textAlign: 'center' }}>
          <h2>Join Our Discord Community</h2>
          <p>
            We'd love to hear from you! Our Discord community is where we share insights, 
            answer questions, and help each other make the most of our dendrometer sensors.
          </p>
          <p style={{ marginTop: 'var(--spacing-lg)', marginBottom: 'var(--spacing-lg)' }}>
            <a 
              href="https://discord.gg/K8AUTAcv7" 
              className="button button-primary"
              target="_blank" 
              rel="noopener noreferrer"
              style={{ display: 'inline-block' }}
            >
              Join Discord Server
            </a>
          </p>
          <p style={{ fontSize: '0.95rem', color: 'var(--color-text-secondary)' }}>
            We'll get back to you as soon as possible.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
}
